export const getAllAmbulancesSuccess = 'GET_ALL_AMBULANCES_SUCCESS';
export const getAllAmbulancesFailure = 'GET_ALL_AMBULANCES_FAILURE';
export const addNewAmbulanceSuccess = 'ADD_NEW_AMBULANCE_SUCCESS';
export const addNewAmbulanceFailure = 'ADD_NEW_AMBULANCE_FAILURE';
export const deleteAmbulanceSuccess = 'DELETE_AMBULANCE_SUCCESS';
export const deleteAmbulancesFailure = 'DELETE_AMBULANCE_FAILURE';
export const editAmbulanceSuccess = 'EDIT_AMBULANCE_SUCCESS';
export const editAmbulanceFailure = 'EDIT_AMBULANCE_FAILURE';